var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "glyphicons-basic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "123px",
    height: "94px",
    viewBox: "66.25 22.25 123 94",
    enableBackground: "new 66.25 22.25 123 94",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "link",
    d: "M180.75,59.906v22.188c0,11.028-8.94,19.969-19.969,19.969h-31.063c-11.028,0-19.969-8.94-19.969-19.969V66.563 c0-2.451,1.987-4.438,4.438-4.438h4.438c2.451,0,4.438,1.987,4.438,4.438v15.531c0,3.676,2.98,6.656,6.656,6.656h31.063 c3.676,0,6.656-2.98,6.656-6.656V59.906c0-3.676-2.98-6.656-6.656-6.656h-7.275c-0.955,0-1.803-0.611-2.105-1.517l-2.958-8.875 c-0.388-1.163,0.24-2.419,1.403-2.807c0.227-0.075,0.463-0.114,0.701-0.114h10.234C171.81,39.938,180.75,48.878,180.75,59.906z  M103.6,90.268c-0.302-0.906-1.15-1.518-2.105-1.518h-7.276c-3.676,0-6.656-2.98-6.656-6.656V59.906c0-3.676,2.98-6.656,6.656-6.656 h31.063c3.676,0,6.656,2.98,6.656,6.656v15.531c0,2.451,1.986,4.438,4.438,4.438h4.438c2.451,0,4.438-1.986,4.438-4.438V59.906 c0-11.028-8.94-19.969-19.969-19.969H94.219c-11.028,0-19.969,8.94-19.969,19.969v22.188c0,11.028,8.94,19.969,19.969,19.969h10.234 c1.226,0,2.219-0.993,2.219-2.219c0-0.238-0.039-0.476-0.114-0.701L103.6,90.268z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.997add4ab19a63d71f893c311d080fa8.svg";
export { ForwardRef as ReactComponent };